/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 4/11/2020
 */

// WARNING!!! Don't import this file in .vue components that may be imported synchronously from App.vue.
// This will lead to circular dependency that will defer import of App from setupAppMain.js
// leading to VueAppContainer.App = null by the moment this file is imported for the first time
// This will give an empty page that will never start
console.log("importing setupVue3.js is called")
import { createApp, shallowReactive } from 'vue'

import VueAppContainer from '@/entry/VueAppContainer.js';


console.log("createApp: setupVue3 before VueAppContainer.appPromise")

let App = VueAppContainer.App
if(App === null){
	console.error("createApp: setupVue3 App is null!!! Make sure this file is not imported from .vue components that may be imported synchronously from App.vue. This will lead to circular dependency that will defer import of App from setupAppMain.js leading to VueAppContainer.App = null by the moment this file is imported for the first time. This will give an empty page that will never start")
}
console.log("createApp: setupVue3 App = ", App)

let app = createApp(App)
app.config.globalProperties = shallowReactive(app.config.globalProperties)

export default app
